module.exports = {"apiUrl":"https://kenguru.stage.qortex.ru"};